import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { PropertyUnit } from './propertyUnit';
import { Structure } from './structure';
import { System } from './system';
import { Interior } from './interior';
import { ManufacturedHome } from './manufacturedHome';

export class ConvertedArea {
    constructor(doc)
    {
		this.label = null;
		this.convertedAreaFinishComparisonType = null;
		this.convertedAreaOriginalUseType = null;
		this.convertedAreaOriginalUseTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.convertedAreaFinishComparisonType = x.getStringElement(doc, "./ns:ConvertedAreaFinishComparisonType");
		this.convertedAreaOriginalUseType = x.getStringElement(doc, "./ns:ConvertedAreaOriginalUseType");
		this.convertedAreaOriginalUseTypeOtherDescription = x.getStringElement(doc, "./ns:ConvertedAreaOriginalUseTypeOtherDescription");
   }
}

export class ImprovementDetail {
    constructor(doc)
    {
		this.label = null;
		this.convertedAreaExistsIndicator = null;
		this.coolingSystemExistsIndicator = null;
		this.dwellingExteriorDefectsExistIndicator = null;
		this.heatingSystemExistsIndicator = null;
		this.improvementType = null;
		this.lackOfHeatingSystemTypicalToMarketIndicator = null;
		this.nonContinuousFinishedAreaIndicator = null;
		this.outbuildingDefectsExistIndicator = null;
		this.outbuildingRealPropertyIndicator = null;
		this.outbuildingType = null;
		this.outbuildingTypeOtherDescription = null;
		this.propertyStructureBuiltYear = null;
		this.propertyStructureBuiltYearEstimatedIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.convertedAreaExistsIndicator = x.getBooleanElement(doc, "./ns:ConvertedAreaExistsIndicator");
		this.coolingSystemExistsIndicator = x.getBooleanElement(doc, "./ns:CoolingSystemExistsIndicator");
		this.dwellingExteriorDefectsExistIndicator = x.getBooleanElement(doc, "./ns:DwellingExteriorDefectsExistIndicator");
		this.heatingSystemExistsIndicator = x.getBooleanElement(doc, "./ns:HeatingSystemExistsIndicator");
		this.improvementType = x.getStringElement(doc, "./ns:ImprovementType");
		this.lackOfHeatingSystemTypicalToMarketIndicator = x.getBooleanElement(doc, "./ns:LackOfHeatingSystemTypicalToMarketIndicator");
		this.nonContinuousFinishedAreaIndicator = x.getBooleanElement(doc, "./ns:NonContinuousFinishedAreaIndicator");
		this.outbuildingDefectsExistIndicator = x.getBooleanElement(doc, "./ns:OutbuildingDefectsExistIndicator");
		this.outbuildingRealPropertyIndicator = x.getBooleanElement(doc, "./ns:OutbuildingRealPropertyIndicator");
		this.outbuildingType = x.getStringElement(doc, "./ns:OutbuildingType");
		this.outbuildingTypeOtherDescription = x.getStringElement(doc, "./ns:OutbuildingTypeOtherDescription");
		this.propertyStructureBuiltYear = x.getStringElement(doc, "./ns:PropertyStructureBuiltYear");
		this.propertyStructureBuiltYearEstimatedIndicator = x.getBooleanElement(doc, "./ns:PropertyStructureBuiltYearEstimatedIndicator");
   }
}

export class OutbuildingUtility {
    constructor(doc)
    {
		this.label = null;
		this.utilityType = null;
		this.utilityTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.utilityType = x.getStringElement(doc, "./ns:UtilityType");
		this.utilityTypeOtherDescription = x.getStringElement(doc, "./ns:UtilityTypeOtherDescription");
   }

	 GetUtilityType() {
		return h.descriptionOrOther(this.utilityType, this.utilityTypeOtherDescription);
	 }
}

export class Outbuilding {
	constructor(doc) {
		this.label = null;
		this.outbuildingUtilities = [];
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:OUTBUILDING_UTILITIES/ns:OUTBUILDING_UTILITY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.outbuildingUtilities.push(new OutbuildingUtility(xn));
			});
		}
	}

	GetUtilityList() {
	var list = [];
	if (this.outbuildingUtilities.length === 0) return list;
	for (var util of this.outbuildingUtilities)
		list.push(util.GetUtilityType());
	return list;
	}

	GetUtilities() {
	var list = [];
	for (var ou of this.outbuildingUtilities)
		list = h.addWithSpacer(list, ou.GetUtilityType());
	return list;
	}

}

export class Improvement {
    constructor(doc, parentProperty)
    {
		this.label = null;
		this.parentProperty = parentProperty;
		this.convertedAreas = [];
		this.improvementDetail = null;
		this.interior = null;
		this.manufacturedHome = null;
		this.outbuilding = null;
		this.propertyUnits = [];
		this.structure = null;
		this.system = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:CONVERTED_AREAS/ns:CONVERTED_AREA");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.convertedAreas.push(new ConvertedArea(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:IMPROVEMENT_DETAIL");
		if (node !== null)
				this.improvementDetail = new ImprovementDetail(node);
		node = x.selectSingleNode(doc, "./ns:INTERIOR");
		if (node !== null)
				this.interior = new Interior(node);
		node = x.selectSingleNode(doc, "./ns:MANUFACTURED_HOME");
		if (node !== null)
				this.manufacturedHome = new ManufacturedHome(node);
		node = x.selectSingleNode(doc, "./ns:OUTBUILDING");
		if (node !== null)
				this.outbuilding = new Outbuilding(node);
		nodes = x.selectNodes(doc, "./ns:PROPERTY_UNITS/ns:PROPERTY_UNIT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.propertyUnits.push(new PropertyUnit(xn, parentProperty, this));
			});
		}
		node = x.selectSingleNode(doc, "./ns:STRUCTURE");
		if (node !== null)
				this.structure = new Structure(node);
		node = x.selectSingleNode(doc, "./ns:SYSTEM");
		if (node !== null)
				this.system = new System(node);
   }

	GetRemainingLifeYears() {
			if (!this.structure)	return undefined;
			var result = this.structure.structureAnalysis.structureAnalysisDetail.estimatedRemainingEconomicLifeYearsCount.toString();
			result += " years";
			return result;
		}

	GetRemainingLifeDescription() {
		if (!this.structure)	return undefined;
		var result = this.structure.structureAnalysis.structureAnalysisDetail.estimatedRemainingEconomicLifeDescription;
		return result;
	}

	GetStructureIsRise() {
		if (!this.structure)	return false;
		var result = this.structure.StructureIsRise();;
		return result;
	}

	GetTotalRoomsCount() {
			let count = 0;
			if (!this.propertyUnits) return count;
			for (const unit of this.propertyUnits) {
					if (unit.rooms) {
							count += unit.rooms.length;
					}
			}
			return count;
	}

	GetBedroomCount() {
			let count = 0;
			if (!this.propertyUnits) return count;
			for (const unit of this.propertyUnits) {
					if (unit.rooms) {
							for (const r of unit.rooms) {
									if (r.roomDetail.roomType === "Bedroom") ++count;
							}
					}
			}
			return count;
	}

	GetBathFullCount() {
			let count = 0;
			if (!this.propertyUnits) return count;
			for (const unit of this.propertyUnits) {
					if (unit.rooms) {
							for (const r of unit.rooms) {
									if (r.roomDetail.roomType === "FullBathroom") ++count;
							}
					}
			}
			return count;
	}

	GetBathHalfCount() {
			let count = 0;
			if (!this.propertyUnits) return count;
			for (const unit of this.propertyUnits) {
					if (unit.rooms) {
							for (const r of unit.rooms) {
									if (r.roomDetail.roomType === "HalfBathroom") ++count;
							}
					}
			}
			return count;
	}

	GetKitchenCount() {
			let count = 0;
			if (!this.propertyUnits) return count;
			for (const unit of this.propertyUnits) {
					if (unit.rooms) {
							for (const r of unit.rooms) {
									if (r.roomDetail.roomType === "Kitchen") ++count;
							}
					}
			}
			return count;
	}

	GetHasHeatingSystem() {
		if (!this.system) return false;
		if (this.system.heatingSystems.length === 0) return false;
		for (var hs of this.system.heatingSystems)	{
				var type = hs.GetHeatingType();
				if (type && type !== "None") return true;
		}
		return false;
	}

	GetHeatingTypes() {
		if (!this.system) return "";
		return this.system.GetHeatingSystemsTypes();
	}

	GetHeatingExistsIndicator() {
			return this.improvementDetail.heatingSystemExistsIndicator ?? false;
	}

	GetCoolingTypes() {
		if (!this.system) return "";
		return this.system.GetCoolingSystemsTypes();
	}

	GetCoolingExistsIndicator() {
			return (this.improvementDetail.coolingSystemExistsIndicator ?? false);
	}

	HasADU() {
		for (const unit of this.propertyUnits)
				if (unit.IsADU()) return true;

		return false;
	}

	GetUnitByLabel(label) {
			for (const unit of this.propertyUnits) {
					if (unit.label === label) return unit;
			}
			return null;
	}

	GetUnitByLabels(labels) {
			for (const unit of this.propertyUnits) {
					if (labels.includes(unit.label)) return unit;
			}
			return null;
	}

	GetConvertedAreaSimilarityList() {
			const list = [];
			if (!this.convertedAreas || this.convertedAreas.length === 0) return list;
			for (const area of this.convertedAreas) {
					let item = area.GetConvertedAreaUseType();
					item = item.addWithSpacer(area.convertedAreaFinishComparisonType);
					list.push(item);
			}
			return list;
	}

	GetYearBuilt() {
			let built = (this.improvementDetail.propertyStructureBuiltYearEstimatedIndicator ?? false) ? "~" : "";
			built += this.improvementDetail.propertyStructureBuiltYear;
			return built;
	}

	GetMechanical(system) {
			let methods = "";
			if (!this.system.mechanicalSystems) return methods;
			for (const ms of this.system.mechanicalSystems) {
					if (ms.mechanicalSystemType === system) {
							methods = h.descriptionOrOther(ms.mechanicalSystemType, ms.mechanicalSystemTypeOtherDescription);
					}
			}
			return methods;
	}

	GetInteriorSummaryRoomCount(roomType) {
			if (!this.interior) return "";
			if (!this.interior.interiorRoomSummaries) return "";
			for (const irs of this.interior.interiorRoomSummaries) {
					if (irs.roomType === roomType) {
							return irs.totalRoomCount.toString();
					}
			}
			return "--";
	}

	GetOutbuildingType() {
			return h.descriptionOrOther(this.improvementDetail.outbuildingType, this.improvementDetail.outbuildingTypeOtherDescription);
	}

	GetImprovementType() {
			return h.toEnumText(this.improvementDetail.improvementType);
	}

	GetManufacturedHomeWidth() {
			if (!this.manufacturedHome) return "";
			return h.toEnumText(this.manufacturedHome.manufacturedHomeDetail.manufacturedHomeWidthType);
	}

	GetNonContinuousRoomSummary() {
			if (!this.interior) return "";
				return this.interior.GetRoomSummaries();
	}
}


export class Improvements {
		constructor(doc, parentProperty) {
				this.pareentProperty = parentProperty;
				this.improvementList = [];
				
				const improvements = x.selectNodes(doc, "ns:IMPROVEMENTS/ns:IMPROVEMENT");
				if (improvements.length > 0) {
						for (const improvement of improvements) {
								this.improvementList.push(new Improvement(improvement, parentProperty));
						}
				}
		}

		GetImprovementLabels() {
				const list = [];
				for (const i of this.improvementList) {
						list.push(i.label);
				}
				return list;
		}

		GetImprovementByLabel(label) {
				for (const improvement of this.improvementList) {
						if (improvement.label === label) return improvement;
				}
				return null;
		}

		GetImprovementByType(type) {
				for (const improvement of this.improvementList) {
						if (improvement.improvementDetail.improvementType === type) return improvement;
				}
				return null;
		}

		GetImprovementsByType(type) {
				const list = [];
				for (const improvement of this.improvementList) {
						if (improvement.improvementDetail.improvementType === type) list.push(improvement);
				}
				return list;
		}

		GetPropertyUnits() {
				const units = [];
				for (const improvement of this.improvementList) {
						for (const propertyUnit of improvement.propertyUnits) {
								units.push(propertyUnit);
						}
				}
				return units;
		}

		GetPropertyUnitByUnit(unitId) {
				for (const improvement of this.improvementList) {
						for (const propertyUnit of improvement.propertyUnits) {
								if (propertyUnit.propertyUnitDetail.unitIdentifier === unitId) return propertyUnit;
						}
				}
				return null;
		}

		GetRentSchedules() {
				const schedules = [];
				for (const improvement of this.improvementList) {
						for (const propertyUnit of improvement.propertyUnits) {
								schedules.push(propertyUnit.unitRentSchedule);
						}
				}
				return schedules;
		}

		GetUnitDefectsExist() {
				for (const improvement of this.improvementList) {
						if (improvement.propertyUnits === null) return false;
						for (const propertyUnit of improvement.propertyUnits) {
								if (propertyUnit.propertyUnitDetail.unitInteriorDefectsExistIndicator === true) return true;
						}
				}
				return false;
		}

		GetOutbuildingDefectsExist() {
				for (const improvement of this.improvementList) {
						if (improvement.improvementDetail.improvementType === "Outbuilding") {
								if (improvement.improvementDetail.outbuildingDefectsExistIndicator === true) return true;
						}
				}
				return false;
		}
}
